export default __webpack_public_path__ + "static/media/open-book.36dd9487.svg";